// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

function PortfolioBeerLocationList({ locationLabels, compact = false }) {
  if (!Array.isArray(locationLabels) || locationLabels.length === 0) {
    return null;
  }

  const headingVariant = compact ? 'caption' : 'subtitle2';
  const itemVariant = compact ? 'caption' : 'body2';
  const headingSx = compact
    ? { mt: 0.5, display: 'block', fontWeight: 600 }
    : { fontWeight: 600, mt: 3, mb: 0.75 };

  return (
    <>
      <Typography variant={headingVariant} color="text.secondary" sx={headingSx}>
        Listed at
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          mt: compact ? 0.25 : 0,
          pl: 2.5,
          color: 'text.secondary',
        }}
      >
        {locationLabels.map((label) => (
          <Typography
            key={label}
            component="li"
            variant={itemVariant}
            color="text.secondary"
          >
            {label}
          </Typography>
        ))}
      </Box>
    </>
  );
}

PortfolioBeerLocationList.propTypes = {
  locationLabels: PropTypes.arrayOf(PropTypes.string),
  compact: PropTypes.bool,
};

export default PortfolioBeerLocationList;
